module.exports = __webpack_public_path__ + "static/media/estudo_cliente.b6e32b39.svg";